<template>
	<svg
		id="Layer_2"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 361.41 70.87"
	>
		<g id="Layer_1-2">
			<path
				class="cls-1"
				d="M126.04,44.48h-15.07v21.96h-13.52V4.43h28.59c12.75,0,21.44,6.46,21.44,18.86v2.15c0,11.71-8.7,19.03-21.44,19.03ZM133.96,24.75v-.69c0-5.43-3.19-8.53-9.65-8.53h-13.35v17.83h13.35c6.46,0,9.65-3.1,9.65-8.61Z"
			/>
			<path
				class="cls-1"
				d="M153.34,66.44V19.16h13.09v6.72c2.67-5.08,7.58-7.41,14.73-7.41h3.1v11.63h-2.24c-10.94,0-15.59,3.36-15.59,13.18v23.17h-13.09Z"
			/>
			<path
				class="cls-1"
				d="M233.86,41.63v2.41c0,13.09-9.82,23.43-23.08,23.43h-1.72c-13.18,0-22.99-10.33-22.99-23.43v-2.41c0-13.18,9.82-23.51,22.99-23.51h1.72c13.26,0,23.08,10.33,23.08,23.51ZM220.77,43.18v-.69c0-9.22-3.62-14.3-10.85-14.3s-10.77,5.08-10.77,14.3v.69c0,9.13,3.62,14.3,10.77,14.3s10.85-5.17,10.85-14.3Z"
			/>
			<path
				class="cls-1"
				d="M238.68,41.03c0-12.83,7.75-22.91,19.72-22.91h1.72c5.51,0,10.33,2.67,13.78,7.06V4.43h13.09v62.01h-13.09v-5.6c-3.36,4.22-8.18,6.63-13.78,6.63h-1.72c-11.97,0-19.72-10.08-19.72-22.91v-3.53ZM262.8,57.48c7.06,0,11.11-5.08,11.11-13.78v-1.81c0-8.7-4.05-13.69-11.11-13.69s-11.02,5-11.02,13.69v1.81c0,8.7,4.05,13.78,11.02,13.78Z"
			/>
			<path
				class="cls-1"
				d="M295.44,15.19V4.43h13.09v10.77h-13.09ZM295.44,66.44V19.16h13.09v47.28h-13.09Z"
			/>
			<path
				class="cls-1"
				d="M347.71,61.36c-3.44,3.88-8.53,6.11-13.61,6.11h-1.64c-10.25,0-17.83-6.2-17.83-15.42v-1.21c0-8.27,6.63-12.92,18.95-14.81,8.27-1.21,13.44-1.81,13.44-4.31v-.86c0-2.41-2.67-3.7-7.32-3.7-5.17,0-7.84,1.72-7.84,4.99v.52h-13.09v-.86c0-8.1,8.27-13.69,19.46-13.69h2.93c11.45,0,18.95,5.34,18.95,13.44v24.37c0,3.45.6,7.15,1.29,10.51h-13.09l-.6-5.08ZM347.02,42.58c-2.67,1.29-6.46,1.81-9.82,2.33-5.08.69-9.47,2.33-9.47,6.55v.43c0,3.96,3.1,6.29,8.96,6.29s10.33-3.79,10.33-8.61v-6.98Z"
			/>
			<path
				class="cls-1"
				d="M35.43,0h-17.72v17.72h17.72v17.72h17.72v17.72h-17.72v-17.72h-17.72v-17.72H0v17.72h17.72v17.72h17.72v17.72c19.57,0,35.43-15.86,35.43-35.43S55,0,35.43,0Z"
			/>
			<rect class="cls-1" y="53.15" width="17.72" height="17.72" />
		</g>
	</svg>
</template>

<style scoped>
.cls-1 {
	fill: #fff;
}

svg {
	padding-top: 8px;
	padding-bottom: 8px;
}

@media screen and (max-width: 1024px) {
	svg {
		padding-top: 4px;
		padding-bottom: 4px;
	}
}
</style>
